<ol *ngIf="numberOfSteps > 0">
  <app-step *ngFor="let _ of [].constructor(numberOfSteps*2-1); index as i" [active]="isActive(i+1)"></app-step>
</ol>
